import {TextField} from '@wandb/weave/components/Form/TextField';
import {debounce} from 'lodash';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import {twMerge} from 'tailwind-merge';

type NumberInputBaseProps = {
  className?: string;
  placeholder: string;
  value: number | undefined;
  disabled?: boolean;
};

type NumberInputProps = NumberInputBaseProps &
  (
    | {clearValue: null; updateSetting: (newVal?: number | null) => void}
    | {clearValue?: undefined; updateSetting: (newVal?: number) => void}
  );

export const NumberInput = ({
  className,
  clearValue,
  placeholder,
  value,
  updateSetting,
  disabled,
}: NumberInputProps) => {
  const debouncedUpdateSetting = useMemo(
    () => debounce(updateSetting, 300),
    [updateSetting]
  );

  const [inputStr, setInputStr] = useState(getStrValue(value));

  const focusedRef = useRef(false);
  useEffect(() => {
    if (!focusedRef.current) {
      setInputStr(getStrValue(value));
    }
  }, [value]);

  return (
    <div className={twMerge('w-[5rem]', className)}>
      <TextField
        type="number"
        placeholder={placeholder}
        value={inputStr}
        disabled={disabled ?? false}
        onFocus={() => {
          focusedRef.current = true;
        }}
        onBlur={() => {
          focusedRef.current = false;
          debouncedUpdateSetting.flush();
        }}
        onChange={(newValStr: string) => {
          setInputStr(newValStr);

          const newVal: number | undefined = parseFloat(newValStr);
          debouncedUpdateSetting(Number.isNaN(newVal) ? clearValue : newVal);
        }}
      />
    </div>
  );
};

const getStrValue = (val: number | undefined) => {
  return val == null ? '' : val.toString();
};
